import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import RootLayout from "@/components/layout/RootLayout";
import Home from "@/pages/Home";
import ErrorPage from "@/pages/ErrorPage";
import ServicesPage from "@/pages/ServicesPage";
import PricingPage from "@/pages/PricingPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ComplexServicesPage from "@/pages/ComplexServicesPage";

// Функція для встановлення темної теми Midnight Blue
const setDarkMidnightTheme = () => {
  const root = document.documentElement;
  root.setAttribute('data-theme', 'midnight');
  root.classList.add('dark');
  localStorage.setItem('theme', 'midnight');
  localStorage.setItem('darkMode', 'true');
};

const queryClient = new QueryClient();

const App = () => {
  // Встановлюємо темну тему Midnight Blue при завантаженні
  useEffect(() => {
    setDarkMidnightTheme();
  }, []);
  
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <Routes>
            <Route element={<RootLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/uslugi" element={<ServicesPage />} />
              <Route path="/kompleksni-poslugy" element={<ComplexServicesPage />} />
              <Route path="/cennik" element={<PricingPage />} />
               {/* редіректи зі старих URL */}
              <Route path="/oferta"  element={<Navigate to="/cennik" replace />} />
              <Route path="/pricing" element={<Navigate to="/cennik" replace />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;